/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-implied-eval */

import PropTypes from 'prop-types';
import { createRef, Component } from 'react';
import I18n from 'I18n';
import { AnyCrmObjectTypePropType, AnyCrmObjectPropType
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
} from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { Map as ImmutableMap, List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import TimelineEventsVirtualized from './TimelineEventsVirtualized';
import TimelineEventsPropType from '../../helpers/TimelineEventsPropType';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { connect } from 'general-store';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { shallowEqualImmutable } from 'react-immutable-render-mixin';
import { buildTypedMap } from 'crm-events-data/types';
import { TIMELINE_STATUSES, TimelineStatusStore, TRIGGER_RHUMB_SUCCESS, RhumbSuccessTriggerContext, SubjectDependency, fetchNextTimelineEvents, fetchMostRecentActivities } from 'crm-events-data';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const now = TimelineStatusStore.get('now');
const ONE_MINUTE = 60000;
const POLLING_INTERVAL = 120000;
const TAB_ACCESSIBILITY_KEYS = {
  ENGAGEMENTS_ACTIVITY: 'timeline.filters.accessibility.activityTabHeading',
  ENGAGEMENTS_CALLS: 'timeline.filters.accessibility.callTabHeading',
  ENGAGEMENTS_EMAILS_TRIMMED: 'timeline.filters.accessibility.emailTabHeading',
  ENGAGEMENTS_MEETINGS: 'timeline.filters.accessibility.meetingTabHeading',
  ENGAGEMENTS_NOTES: 'timeline.filters.accessibility.noteTabHeading',
  ENGAGEMENTS_TASKS: 'timeline.filters.accessibility.taskTabHeading'
};
class TimelineVirtualized extends Component {
  constructor(props) {
    super(props);
    this.getIntervals = () => {
      return {
        polling: {
          handler: this.handleTimelinePolling,
          timeout: POLLING_INTERVAL
        }
      };
    };
    this.getIsErrorState = () => {
      return this.props.timelineStatus.get('status') === TIMELINE_STATUSES.ERROR;
    };
    this.hasEventsForOverride = () => {
      const {
        timelineStatus
      } = this.props;
      return timelineStatus.get('hasMore') || timelineStatus.get('events') && timelineStatus.get('events').size;
    };
    this.handleShowMore = () => {
      const {
        timelineStatus,
        objectType,
        subjectId,
        timelineFavoriteEvents,
        selectedTeams,
        selectedOwners,
        searchText
      } = this.props;
      const nextTimestamp = timelineStatus.get('nextTimestamp');
      const originalPayload = buildTypedMap({
        eventOptions: timelineFavoriteEvents,
        now,
        objectType,
        subjectId,
        toDate: nextTimestamp,
        selectedTeams,
        selectedOwners,
        searchText
      });
      return fetchNextTimelineEvents(originalPayload);
    };
    this.handleTimelinePolling = () => {
      const {
        objectType,
        shouldDisablePolling,
        subjectId,
        timelineFavoriteEvents
      } = this.props;
      if (shouldDisablePolling) {
        return;
      }
      const pollingTimeout = POLLING_INTERVAL + ONE_MINUTE;
      const pollFromTimestamp = I18n.moment.userTz().subtract(pollingTimeout, 'ms').valueOf();
      const originalPayload = buildTypedMap({
        eventOptions: timelineFavoriteEvents,
        fromDate: pollFromTimestamp,
        now,
        objectType,
        subjectId
      });
      fetchMostRecentActivities(originalPayload);
    };
    this.handleTriggerRhumbSuccess = () => {
      // used to tell us if the timeline has loaded without error, for more info
      // see https://product.hubteam.com/docs/frontend/docs/react-rhumb.html
      if (!this.getIsErrorState() && !this.hasTriggeredRhumbSuccess) {
        this.props.handleTimelineAction(TRIGGER_RHUMB_SUCCESS);
        this.hasTriggeredRhumbSuccess = true;
      }
    };
    this.renderTimelineContent = () => {
      return /*#__PURE__*/_jsx(RhumbSuccessTriggerContext.Provider, {
        value: this.handleTriggerRhumbSuccess,
        children: /*#__PURE__*/_jsx(TimelineEventsVirtualized, {
          events: this.props.events,
          emailTabIsSelected: this.props.emailTabIsSelected,
          objectType: this.props.objectType,
          onShowMore: this.handleShowMore,
          onTimelineEventsChanged: this.handleTimelinePolling,
          profileStartTime: this.props.profileStartTime,
          shouldDisplayPinnedEngagement: this.props.shouldDisplayPinnedEngagement,
          subject: this.props.subject,
          subjectId: this.props.subjectId,
          timelineLoadStartTime: this.state.startTime
        })
      });
    };
    this.timelineSpinnerRef = /*#__PURE__*/createRef();
    this.state = {
      hasCompletedFirstFetch: false,
      hasStartedFirstFetch: false,
      hasTriggeredRhumbSuccess: false,
      startTime: performance.now()
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqualImmutable(this.props, nextProps) || !shallowEqualImmutable(this.state, nextState);
  }
  componentDidMount() {
    this._intervals = {};
    const getIntervalsResult = this.getIntervals() || {};
    Object.keys(getIntervalsResult).forEach(intervalKey => {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      const {
        handler,
        timeout
      } = getIntervalsResult[intervalKey];
      this._intervals[intervalKey] = setInterval(handler, timeout);
    });
  }
  componentWillUnmount() {
    Object.keys(this._intervals).forEach(key => clearInterval(this._intervals[key]));
  }
  render() {
    const accessibilityHeadingMessage =
    // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
    TAB_ACCESSIBILITY_KEYS[this.props.selectedTab];
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
        children: /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: accessibilityHeadingMessage
          })
        })
      }), this.renderTimelineContent()]
    });
  }
}
TimelineVirtualized.propTypes = {
  activityTabIsSelected: PropTypes.bool,
  emailTabIsSelected: PropTypes.bool,
  events: TimelineEventsPropType,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  favoriteEventOverride: PropTypes.instanceOf(ImmutableMap),
  handleTimelineAction: PropTypes.func,
  objectType: AnyCrmObjectTypePropType.isRequired,
  profileStartTime: PropTypes.number,
  searchText: PropTypes.string.isRequired,
  selectedTab: PropTypes.string,
  selectedTeams: ImmutablePropTypes.list.isRequired,
  selectedOwners: ImmutablePropTypes.list.isRequired,
  shouldDisablePolling: PropTypes.bool,
  shouldDisplayPinnedEngagement: PropTypes.bool,
  subject: AnyCrmObjectPropType,
  subjectId: PropTypes.string.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  timelineFavoriteEvents: PropTypes.instanceOf(List),
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  timelineStatus: PropTypes.instanceOf(ImmutableMap)
};
TimelineVirtualized.defaultProps = {
  activityTabIsSelected: false
};
export default connect({
  subject: SubjectDependency
})(TimelineVirtualized);
// For testing
export { TimelineVirtualized as WrappedComponent };